import moment from 'moment-timezone';
export const GET_RECORDING_DETAILS_REQUEST = 'GET_RECORDING_DETAILS_REQUEST';
export const GET_RECORDING_DETAILS_SUCCESS = 'GET_RECORDING_DETAILS_SUCCESS';
export const GET_RECORDING_DETAILS_FAILURE = 'GET_RECORDING_DETAILS_FAILURE';
export const FILTER_RECORDING_VIEWS = 'FILTER_RECORDING_VIEWS';

const defaultFilter = {
  fromTime: moment()
    .subtract(1, 'year')
    .startOf('day')
    .toISOString(),
  toTime: moment()
    .endOf('day')
    .toISOString(),
  searchString: ''
};
export function getRecordingDetails(recordingKey, recordingSource) {
  return {
    type: GET_RECORDING_DETAILS_REQUEST,
    payload: { recordingKey, recordingSource, filter: defaultFilter }
  };
}

export function filterRecordingViews(filterOptions) {
  let { fromTime, toTime, searchString } = filterOptions;
  return {
    type: FILTER_RECORDING_VIEWS,
    payload: { searchString, fromTime, toTime }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/RecordingDetails/RecordingDetailsActions.js